module.exports = "button.btn_agregar{max-width:171px}.agregar-categoria.modal{width:373px;height:359px}\n"